export const EVENT_DELETION_CONFIRMATION_DIALOG_ID = 'EventDeletionConfirmationDialog'
